// removed by extract-text-webpack-plugin
module.exports = {"clearfix":"src-components-QRcode-Modal-__EditModal-module___clearfix"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QRcode/Modal/EditModal.module.css
// module id = 1255
// module chunks = 1